import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { ThemeConfig } from "../../dataTypes/ThemeConfig";
import { useParams } from "react-router-dom";

// Define the type for the CustomTooltip props
interface CustomTooltipProps {
  active?: boolean;
  payload?: { name: string; value: number }[];
  label?: string;
}

// Define the CustomTooltip component
const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #CCCCCC",
          padding: "10px",
          fontWeight: 500,
        }}
      >
        <p
          className="label"
          style={{ margin: "0px", marginBottom: "4px" }}
        >{`${label}`}</p>
        <p
          className="intro"
          style={{ margin: "0px" }} // Use themeConfig.color here
        >{`${payload[0].name}: ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

// Define the type for the CustomLineChart props
interface CustomLineChartProps {
  data: { date: string; count: number }[];
  themeConfig?: ThemeConfig;
  keyName: string;
}

const CustomLineChart: React.FC<CustomLineChartProps> = ({
  data,
  themeConfig,
  keyName,
}) => {
  const { slug } = useParams<{ slug: string }>();

  return (
    <ResponsiveContainer
      width="80%"
      height={300}
      style={{ paddingLeft: "100px" }}
    >
      <AreaChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="top" height={36} />
        <Area
          type="monotone"
          dataKey={keyName}
          stroke={slug === "clubedemo" ? "#82CA9D" : themeConfig?.color}
          fill={
            slug === "clubedemo"
              ? "rgba(130, 202, 157, 0.5)"
              : themeConfig?.color
          }
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
